import api from "./api";
import currentUserId from "../reduxSaga/sagas/requests/currentUserId";

const addWarehouseTransfert = (warehouseTransfertModel) => {
  return api.post(
    "/retail/warehouse/addWarehouseTransfert",
    warehouseTransfertModel
  );
};

const addWarehouseTransfertAdmin = (warehouseTransfertModel) => {
  return api.post(
    "/retail/warehouse/addWarehouseTransfertAdmin",
    warehouseTransfertModel
  );
};
const getTransfertExistance = (refTransfert) => {
  let currentUser = currentUserId();
  return api.get(
    `/retail/warehouse/getTransfertExistance/${currentUser}/${refTransfert}`
  );
};

const getWarehouseTransfert = (isDeleted, isConfirmed) => {
  let currentUser = currentUserId();
  return api.get(
    `/retail/warehouse/getWarehouseTransfert/${currentUser}/${isDeleted}/${isConfirmed}`
  );
};

const getWarehouseTransfertPaginated = (
  isDeleted,
  isConfirmed,
  page = 0,
  size = 10
) => {
  let currentUser = currentUserId();
  return api.get(
    `/retail/warehouse/getWarehouseTransfertPaginated/${currentUser}/${isDeleted}/${isConfirmed}`,
    { params: { page, size } }
  );
};

const updateWarehouseTransfertIsConfirmed = (
  idWarehouseTransfert,
  isConfirmed
) => {
  let currentUser = currentUserId();
  return api.post(
    `/retail/warehouse/updateWarehouseTransfertIsConfirmed/${currentUser}/${idWarehouseTransfert}/${isConfirmed}`
  );
};

const deleteAndRestoreWarehouseTransfert = (
  idWarehouseTransfert,
  isDeleted
) => {
  let currentUser = currentUserId();
  return api.post(
    `/retail/warehouse/deleteAndRestoreWarehouseTransfert/${currentUser}/${idWarehouseTransfert}/${isDeleted}`
  );
};
const getWarehouseTransfertProducts = (idUser, refTransfert) => {
  let currentUser = currentUserId();
  return api.get(
    `/retail/warehouse/getWarehouseTransfertProducts/${idUser}/${refTransfert}`
  );
};

const getWarehouseTransfertProductsInformations = (refTransfert) => {
  let currentUser = currentUserId();
  return api.get(
    `/retail/warehouse/getWarehouseTransfertProducts/${currentUser}/${refTransfert}`
  );
};

const transfertProcessingByWarehouseManager = (idUser, refTransfert) => {
  let currentUser = currentUserId();
  return api.post(
    `/retail/warehouse/transfertProcessingByWarehouseManager/${currentUser}/${refTransfert}`
  );
};

const getWarehouseTransfertByWarhouseManager = (
  sourceOrDestination,
  dateStart,
  dateEnd,
  status
) => {
  let currentUser = currentUserId();

  return api.get(
    `/retail/warehouse/getWarehouseTransfertByWarhouseManager/${currentUser}/${sourceOrDestination}/${dateStart}/${dateEnd}/${status}`
  );
};

export default {
  addWarehouseTransfert,
  addWarehouseTransfertAdmin,
  getTransfertExistance,
  getWarehouseTransfert,
  getWarehouseTransfertPaginated,
  updateWarehouseTransfertIsConfirmed,
  deleteAndRestoreWarehouseTransfert,
  getWarehouseTransfertProducts,
  transfertProcessingByWarehouseManager,
  getWarehouseTransfertByWarhouseManager,
  getWarehouseTransfertProductsInformations,
};
